import React from 'react'
import Button from './Button'
import withCdnUrl from './withCdnUrl'

class Intro extends React.Component {
  constructor(props) {
    super(props)
  }

  joinAsPlayer = () => {
    const url = `https://app.playvs.com/sign-up/player`
    window.open(url, '_blank')
  }

  joinAsCoach = () => {
    const url = `https://app.playvs.com/sign-up/coach`
    window.open(url, '_blank')
  }

  render() {
    return (
      <div className="intro">
        <img src={`${this.props.cdnUrl}images/illustrations/playVs_hero.jpg`} />
        <div className="container">
          <div className="intro__content">
            <h1>Compete for an Esports State Championship</h1>
            <p>
              Take your gameplay to the next level by competing against other schools for the state title in
              your official high school esports league.
            </p>
          </div>
          <div className="intro__actions">
            <ul>
              <li>
                <Button
                  type="button"
                  className="btn btn__primary"
                  text="Sign up to play"
                  onClick={this.joinAsPlayer}
                />
              </li>
              <li>
                <Button
                  type="button"
                  className="btn btn__reverse"
                  text="Request to coach"
                  onClick={this.joinAsCoach}
                />
              </li>
            </ul>
          </div>
        </div>

        {/*<div className="intro__mask intro__mask--fadeToRight"></div>*/}
      </div>
    )
  }
}

export default withCdnUrl(Intro)



// WEBPACK FOOTER //
// ./src/common/ui/components/IntroSecondary.js